/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import MaxLengthNumericEditor from '../../../../SharedModules/CustomAgGridEditor/inputComponent';
import * as Styles from '../../../../SharedModules/StyleConstant/StyleConstant';
import { NumberAndAlphabetComparator } from '../../../../SharedModules/utilities/utilities';

export const getValueFromRefData = (refData, key, value) => {
  if (refData && refData[key] && refData[key].length > 0) {
    const filterArr = refData[key].filter(
      (item) => item && item.codeValueID && item.codeValueID.codeValue === value
    );

    return filterArr.length > 0 ? filterArr[0].shortDescription : value;
  }
  return value;
};
function monthToComparableNumber(date) {
  if (date === undefined || date === null || date.length !== 10) {
    return null;
  }
  const yearNumber = Number.parseInt(date.substring(6, 10));
  const dayNumber = Number.parseInt(date.substring(3, 5));
  const monthNumber = Number.parseInt(date.substring(0, 2));
  return yearNumber * 10000 + monthNumber * 100 + dayNumber;
}
function dateComparator(date1, date2) {
  const date1Number = monthToComparableNumber(date1);
  const date2Number = monthToComparableNumber(date2);
  if (date1Number === null && date2Number === null) {
    return 0;
  }
  if (date1Number === null) {
    return -1;
  }
  if (date2Number === null) {
    return 1;
  }
  return date1Number - date2Number;
}
function amountComparator(amount1, amount2) {
  let amt1 = null;
  let amt2 = null;
  if (amount1 && amount1?.toString()?.includes('$')) {
    amt1 = parseFloat(
      amount1?.toString().split('$')[1]?.toString()?.replace(',', '').trim()
    );
  } else {
    amt1 = parseFloat(amount1?.toString()?.replace(',', '').trim());
  }
  if (amount2 && amount2?.toString()?.includes('$')) {
    amt2 = parseFloat(
      amount2?.toString().split('$')[1]?.toString()?.replace(',', '').trim()
    );
  } else {
    amt2 = parseFloat(amount2?.toString()?.replace(',', '').trim());
  }
  if (amt1 === null && amt2 === null) {
    return 0;
  }
  if (amt1 === null) {
    return -1;
  }
  if (amt2 === null) {
    return 1;
  }

  return amt1 - amt2;
}

export const DISPLAY_CHECK_LIST_TABLEHEAD = (
  data = null,
  systemParameter = null
) => {
  const tableHead = [];
  tableHead.push({
    headerName: 'Action',
    minWidth: 110,
    maxLength: Styles.Length_255,
    filter: false,
    sortable: false,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    cellRendererSelector: (params) => {
      if (params.node.rowPinned) {
        return { component: 'totalText' };
      }
      return { component: 'actionRenderer' };
    },
    pdfExportOptions: {
      skipColumn: true,
    },
  });

  tableHead.push({
    headerName: 'Check Log Number',
    field: 'checkLogNum',
    sort: 'asc',
    editable: false,
    sortable: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_160,
    cellEditor: MaxLengthNumericEditor,
    excelAlignment: 'right',
    cellStyle: { textAlign: 'right', 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    cellRenderer: 'checkLogNumberRender',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  });
   tableHead.push({
      headerName: 'Batch Date',
      field: 'batchDt',
      comparator: dateComparator,
      editable: false,
      sortable: true,
      suppressMenu: false,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      minWidth: Styles.Width_130,
      cellEditor: MaxLengthNumericEditor,
      cellStyle: { 'border-right-color': Styles.BorderColor },
      sortingOrder: ['desc', 'asc'],
      filter: 'agTextColumnFilter',
      filterParams: {
        defaultOption: 'startsWith',
        suppressAndOrCondition: true,
        buttons: ['reset'],
        refreshValuesOnOpen: true,
      },
    });

  if (systemParameter && systemParameter.checkLogByCcnInd === 1) {
    tableHead.push({
      headerName: 'CCN',
      field: 'checkIdentifier',
      editable: false,
      sortable: true,
      minWidth: Styles.Width_180,
      cellEditor: MaxLengthNumericEditor,
      cellRenderer: 'NameRenderCheckIdentifier',
      cellStyle: { 'border-right-color': Styles.BorderColor },
      sortingOrder: ['desc', 'asc'],
      filter: 'agTextColumnFilter',
      cellClass: 'frr-ellipsis-text',
      filterParams: {
        defaultOption: 'startsWith',
        suppressAndOrCondition: true,
        buttons: ['reset'],
        refreshValuesOnOpen: true,
      },
    });
  }

  if (systemParameter && systemParameter.checkLogUsesBatchInd === 1) {
    tableHead.push({
      headerName: 'Batch Number',
      field: 'batchNum',
      editable: false,
      sortable: true,
      suppressMenu: false,
      minWidth: Styles.Width_180,
      cellEditor: MaxLengthNumericEditor,
      cellRenderer: 'NameRenderBatchNum',
      cellClass: 'frr-ellipsis-text',
      cellStyle: { 'border-right-color': Styles.BorderColor },
      sortingOrder: ['desc', 'asc'],
      filter: 'agTextColumnFilter',
      filterParams: {
        defaultOption: 'startsWith',
        suppressAndOrCondition: true,
        buttons: ['reset'],
        refreshValuesOnOpen: true,
      },
    });

   
  }

  tableHead.push(
    ...[
      {
        headerName: 'Check Number',
        field: 'checkNum',
        editable: false,
        sortable: true,
        autoHeight: true,
        wrapText: true,
        minWidth: Styles.Width_200,
        cellEditor: MaxLengthNumericEditor,
        cellStyle: { 'border-right-color': Styles.BorderColor },
        sortingOrder: ['desc', 'asc'],
        filter: 'agTextColumnFilter',
        filterParams: {
          defaultOption: 'startsWith',
          suppressAndOrCondition: true,
          buttons: ['reset'],
          refreshValuesOnOpen: true,
        },
      },
      {
        headerName: 'Check Issuer',
        field: 'checkIssuer',
        editable: false,
        sortable: true,
        suppressMenu: false,
        columnSpan: 3,
        minWidth: Styles.Width_280,
        cellEditor: MaxLengthNumericEditor,
        cellRenderer: 'NameRenderCheckIssuer',
        comparator: NumberAndAlphabetComparator,
        cellStyle: { 'border-right-color': Styles.BorderColor },
        sortingOrder: ['asc', 'desc'],
        filter: 'agTextColumnFilter',
        cellClass: 'frr-ellipsis-text',
        filterParams: {
          defaultOption: 'startsWith',
          suppressAndOrCondition: true,
          buttons: ['reset'],
          refreshValuesOnOpen: true,
        },
      },
      {
        headerName: '',
        field: '',
        removeColumn: true,
        minWidth: 1,
        resizable: false,
        editable: false,
      },
      {
        headerName: '',
        field: '',
        removeColumn: true,
        minWidth: 1,
        resizable: false,
        editable: false,
      },
      {
        headerName: 'Check Amt',
        field: 'checkAmt',
        comparator: amountComparator,
        editable: false,
        sortable: true,
        suppressMenu: false,
        isTextColorRed: true,
        autoHeight: true,
        wrapText: true,
        minWidth: Styles.Width_160,
        cellEditor: MaxLengthNumericEditor,
        cellRenderer: 'CheckAmtCellRender',
        printPrefixValue: '$ ',
        exportZeroesTwo: true,
        cellStyle: {
          textAlign: 'right',
          'border-right-color': Styles.BorderColor,
        },
        sortingOrder: ['desc', 'asc'],
        filter: 'agTextColumnFilter',
        filterParams: {
          defaultOption: 'startsWith',
          suppressAndOrCondition: true,
          buttons: ['reset'],
          refreshValuesOnOpen: true,
        },
      },
      {
        headerName: 'Allocated Amt',
        field: 'totAllocatedAmt',
        comparator: amountComparator,
        editable: false,
        sortable: true,
        suppressMenu: false,
        isTextColorRed: true,
        autoHeight: true,
        wrapText: true,
        printPrefixValue: '$ ',
        exportZeroesTwo: true,
        minWidth: Styles.Width_180,
        cellEditor: MaxLengthNumericEditor,
        cellRenderer: 'TotAllocatedAmtCellRender',
        cellStyle: {
          textAlign: 'right',
          'border-right-color': Styles.BorderColor,
        },
        sortingOrder: ['desc', 'asc'],
        filter: 'agTextColumnFilter',
        filterParams: {
          defaultOption: 'startsWith',
          suppressAndOrCondition: true,
          buttons: ['reset'],
          refreshValuesOnOpen: true,
        },
      },
      {
        headerName: 'Check Date',
        field: 'checkDt',
        comparator: dateComparator,
        editable: false,
        sortable: true,
        suppressMenu: false,
        wrapHeaderText: true,
        autoHeaderHeight: true,
        minWidth: Styles.Width_130,
        cellEditor: MaxLengthNumericEditor,
        cellStyle: { 'border-right-color': Styles.BorderColor },
        sortingOrder: ['desc', 'asc'],
        filter: 'agTextColumnFilter',
        filterParams: {
          defaultOption: 'startsWith',
          suppressAndOrCondition: true,
          buttons: ['reset'],
          refreshValuesOnOpen: true,
        },
      },
      {
        headerName: 'Postmark Date',
        field: 'postmarkedDt',
        comparator: dateComparator,
        editable: false,
        sortable: true,
        suppressMenu: false,
        wrapHeaderText: true,
        autoHeaderHeight: true,
        minWidth: Styles.Width_150,
        cellEditor: MaxLengthNumericEditor,
        cellStyle: { 'border-right-color': Styles.BorderColor },
        sortingOrder: ['desc', 'asc'],
        filter: 'agTextColumnFilter',
        filterParams: {
          defaultOption: 'startsWith',
          suppressAndOrCondition: true,
          buttons: ['reset'],
          refreshValuesOnOpen: true,
        },
      },
      {
        headerName: 'Received Date',
        field: 'receivedDt',
        comparator: dateComparator,
        editable: false,
        sortable: true,
        suppressMenu: false,
        wrapHeaderText: true,
        autoHeaderHeight: true,
        minWidth: Styles.Width_150,
        cellEditor: MaxLengthNumericEditor,
        cellStyle: { 'border-right-color': Styles.BorderColor },
        sortingOrder: ['desc', 'asc'],
        filter: 'agTextColumnFilter',
        filterParams: {
          defaultOption: 'startsWith',
          suppressAndOrCondition: true,
          buttons: ['reset'],
          refreshValuesOnOpen: true,
        },
      },
      {
        headerName: 'Suspended Date',
        field: 'suspendedDt',
        comparator: dateComparator,
        editable: false,
        sortable: true,
        suppressMenu: false,
        wrapHeaderText: true,
        autoHeaderHeight: true,
        minWidth: Styles.Width_150,
        cellEditor: MaxLengthNumericEditor,
        cellStyle: { 'border-right-color': Styles.BorderColor },
        sortingOrder: ['desc', 'asc'],
        filter: 'agTextColumnFilter',
        filterParams: {
          defaultOption: 'startsWith',
          suppressAndOrCondition: true,
          buttons: ['reset'],
          refreshValuesOnOpen: true,
        },
      },
      {
        headerName: 'Payment Type',
        field: 'paymentMediaTypeCd',
        editable: false,
        sortable: true,
        suppressMenu: false,
        autoHeight: true,
        wrapText: true,
        minWidth: Styles.Width_200,
        cellEditor: MaxLengthNumericEditor,
        cellStyle: { 'border-right-color': Styles.BorderColor },
        sortingOrder: ['desc', 'asc'],
        filter: 'agTextColumnFilter',
        filterParams: {
          defaultOption: 'startsWith',
          suppressAndOrCondition: true,
          buttons: ['reset'],
          refreshValuesOnOpen: true,
        },
      },
      {
        headerName: 'Invoice Reconciliation Format',
        field: 'invRecFormatCd',
        editable: false,
        sortable: true,
        autoHeight: true,
        wrapText: true,
        minWidth: Styles.Width_150,
        cellEditor: MaxLengthNumericEditor,
        cellStyle: { 'border-right-color': Styles.BorderColor },
        sortingOrder: ['desc', 'asc'],
        filter: 'agTextColumnFilter',
        filterParams: {
          defaultOption: 'startsWith',
          suppressAndOrCondition: true,
          buttons: ['reset'],
          refreshValuesOnOpen: true,
        },
      },
      {
        headerName: 'Dispute Resolution',
        field: 'disputeResolutionCd',
        editable: false,
        sortable: true,
        suppressMenu: false,
        autoHeight: true,
        wrapText: true,
        minWidth: Styles.Width_150,
        cellEditor: MaxLengthNumericEditor,
        cellStyle: { 'border-right-color': Styles.BorderColor },
        sortingOrder: ['desc', 'asc'],
        filter: 'agTextColumnFilter',
        filterParams: {
          defaultOption: 'startsWith',
          suppressAndOrCondition: true,
          buttons: ['reset'],
          refreshValuesOnOpen: true,
        },
      },

      {
        headerName: 'Information',
        field: 'checkInfo',
        editable: false,
        sortable: true,
        suppressMenu: false,
        columnSpan: 3,
        minWidth: Styles.Width_280,
        cellEditor: MaxLengthNumericEditor,
        cellRenderer: 'NameRenderInformation',
        cellStyle: { 'border-right-color': Styles.BorderColor },
        sortingOrder: ['desc', 'asc'],
        filter: 'agTextColumnFilter',
        cellClass: 'frr-ellipsis-text',
        filterParams: {
          defaultOption: 'startsWith',
          suppressAndOrCondition: true,
          buttons: ['reset'],
          refreshValuesOnOpen: true,
        },
      },
      {
        headerName: '',
        field: '',
        removeColumn: true,
        minWidth: 1,
        resizable: false,
        editable: false,
      },
      {
        headerName: '',
        field: '',
        removeColumn: true,
        minWidth: 1,
        resizable: false,
        editable: false,
      },
    ]
  );

  return tableHead;
};
